import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../teamschat-dialog.action';
import { TeamschatDialogState } from '../teamschat-dialog.state';

import { UpdateChatResult } from './update-chat.action';

export function updateChatResultReducer(
    state: TeamschatDialogState,
    action: PayloadAction<ActionType, UpdateChatResult>,
): TeamschatDialogState {
    return {
        ...state,
        chat: {
            ...state.chat,
            topic: action.payload.chat.topic,
            lastUpdatedOn: action.payload.chat.lastUpdatedOn,
        },
    };
}
